module Meevo.Plugins.EmployeeTemplatePromotions {
  "use strict";

  /**
  * Deduction Section of Employee 
  */
  export class DeductionSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeTemplateDeduction> {

  }
}